import { ContentData, ContentResponse } from "./data-provider";
import { FilterData, FilterResponse } from "./filter-provider";

const defaultRequestOptions = {
    method: "POST",
    headers: {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
    },
};

function isMockUrl(url: string): boolean {
    return url.indexOf("mock-data/") > -1;
}

export interface ApiResponse<T = any> extends Response {
    /** Overrides the the native Response interface with data signature */
    json: () => Promise<T>;
}

function request<T>(
    endpoint: string,
    query: string = ""
): Promise<ApiResponse<T>> {
    if (isMockUrl(endpoint)) {
        return fetch(`${endpoint}?${query}`);
    }
    return fetch(endpoint, {
        ...defaultRequestOptions,
        body: query,
    });
}

export async function requestContentData<T = any>(
    endpoint: string,
    query: string
): Promise<ContentResponse<T>> {
    return request<ContentData<T>>(endpoint, query);
}

export async function requestFilter(
    endpoint: string,
    query: string
): Promise<FilterResponse> {
    return request<FilterData>(endpoint, query);
}
